<template>
  <v-row dense>
    <v-col cols="12">
      <Filtro/>
    </v-col>
    <v-col cols="12">
      <Table/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Concorcio',

  components: {
    Filtro: () => import('./components/Filtro'),
    Table: () => import('./components/Table')
  }
}
</script>
